/*       */

import { gql } from '@apollo/client';

export default gql`
    query definitionsLeftPanelListQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        records: processDefinitions(startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            id
            name
            iconName
            iconColor
            iconType
            primary(fields: ["definition"])
        }
    }
`;
